module.exports = [
'with',
'and',
'or',
'the',
'an',  
'is', 
'are', 
'what',
'why',
'how',
'which',
'it',
'this',
'that',
'data'
]